import { ActivatedRoute, Router } from '@angular/router';
import { CommanUsesService } from './../../services/comman-uses.service';
import { Component, OnInit } from '@angular/core';
import { PartnerService } from 'src/app/services/partner.service';
import { loadStripe } from '@stripe/stripe-js';
import { environment } from 'src/environments/environment';
import { Partner } from 'src/app/models/partner.schema';
import { FormBuilder, Validators } from '@angular/forms';
import { StripeService } from 'src/app/services/stripe.service';
import { AuthStatusService } from 'src/app/services/auth-status.service';

@Component({
  selector: 'app-partner-stripe-card-form',
  templateUrl: './partner-stripe-card-form.component.html',
  styleUrls: ['./partner-stripe-card-form.component.scss']
})
export class PartnerStripeCardFormComponent implements OnInit {

  groups: string[];
  stripe: any;
  elements: any;
  card: any;
  partnerStripeCard: any;
  partnerStripeCartForm: any;
  partners: Partner[] = [];
  initialPartners: Partner[] = [];
  formValidationMsgs: any;
  btnDisabled: boolean = false;
  loggedInPartner: Partner;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private commanUsesService: CommanUsesService,
    private partnerService: PartnerService,
    private fb: FormBuilder,
    private stripeService: StripeService,
    private authStatusService: AuthStatusService,
  ) { 
    this.partnerStripeCartForm = this.fb.group({
      partner: ['', Validators.required]
    });

    this.formValidationMsgs = {
      'partner': [{ type: 'required', message: 'Obbligatorio' }]
    };

    this.groups = this.authStatusService.getRoles().map((elem: string) => elem.toLowerCase());
  }

  async ngOnInit() {
    try {
      const loggedInUserInfo = await this.authStatusService.getTokenInfo();
      if(this.groups.includes('partner')){
        this.loggedInPartner = await this.partnerService.getOne(loggedInUserInfo['extraId']);
        this.partnerStripeCartForm.get('partner').setValue(this.loggedInPartner.id);
      }
      await this.loadInitialData();
      this.managePartnerStripeCartForm();
      if(this.partnerStripeCartForm) {
        this.mountCartElement();
      }
    } catch (error) {
      
    }
  }

  managePartnerStripeCartForm() {

  }

  async mountCartElement() {
    this.stripe = await loadStripe(environment.stripePublishableKey);
    this.elements = this.stripe.elements();
    this.card = this.elements.create('card');
    this.card.mount('#card-element');
  }

  async loadInitialData() {
    try {
      try {
        [
          this.partners
        ] = await Promise.all([
          this.partnerService.getAllActivePartnersForDelivery().then(res => res.partners),
        ]);
        this.initialPartners = this.partners;
        
        if(this.groups.includes('partner')) {
          this.partners = this.partners.filter((partner) => partner.id === this.loggedInPartner.id);
        }
      } catch {}
    } catch (error) {
      
    }
  }

  async onSubmit() {
    try {
      if(this.partnerStripeCartForm.valid && this.card) {

        this.btnDisabled = true;
        const partnerId = this.partnerStripeCartForm.get('partner')?.value;

        try {
          const customer = await this.stripeService.createStripeCustomer(partnerId);

          const { token, error } = await this.stripe.createToken(this.card);
          
          if (error) {
            // this.handleStripeError(error);
            const errMsg = error?.error?.message || error?.message || `Qualcosa è andato storto. Per favore, riprova più tardi.`;
            this.commanUsesService.showSnackBar(errMsg);
            this.btnDisabled = false;
            console.error('Error creating payment method:', error);
            return;
          } else {
            try {
              const response = await this.stripeService.attachCard({
                token: token.id,
                customerId: customer?.id
              });
              console.log("response", response);
              if(response) {
                this.router.navigate(['partner/cards']);
              } else {
              }
            } catch (error) {
              const errMsg = error?.error?.message || error?.message;
              this.commanUsesService.showSnackBar(errMsg);
            }
          }
        } catch (error) {
          const errMsg = error?.error?.message || error?.message;
          this.commanUsesService.showSnackBar(errMsg);
        }
      } else {
        this.btnDisabled = false;
        this.commanUsesService.showSnackBar('UNVALIDATED_FORM');
      }
    } catch (error) {
      this.btnDisabled = false;
      const errMsg = error?.error?.message || error?.message;
      this.commanUsesService.showSnackBar(errMsg);
    }
  }

  handleStripeError(error: any) {
    let errorMessage = '';
    if (error.type === 'validation_error') {
      if (error.code === 'incomplete_number') {
        errorMessage = 'Il numero della carta è invalido. Per favore, verifica il numero e riprova.';
      } else if (error.code === 'incomplete_expiry') {
        errorMessage = 'La data di scadenza della tua carta è incompleta. Per favore, verifica e riprova.';
      } else if (error.code === 'incomplete_cvc') {
        errorMessage = 'Il codice CVC è errato. Per favore, verifica e riprova.';
      } else if (error.code === 'incomplete_zip') {
        errorMessage = 'Il tuo codice postale è incompleto. Per favore, verifica e riprova.';
      } else if (error.code === 'expired_card') {
        errorMessage = 'La carta è scaduta. Per favore, usa una carta valida.';
      } else if (error.code === 'card_declined') {
        errorMessage = 'La carta è stata rifiutata. Per favore, prova con una carta diversa.';
      } else if (error.code === 'invalid_expiry_year_past') {
        errorMessage = `L'anno di scadenza della tua carta è già trascorso.`;
      } else {
        errorMessage = 'C\'è stato un errore con il metodo di pagamento. Per favore, riprova.';
      }
    } else {
      errorMessage = 'Qualcosa è andato storto. Per favore, riprova più tardi.';
    }

    this.commanUsesService.showSnackBar(errorMessage);
  }

}
